import apiClient from 'src/Common/apiClient'

export const fetchLessonLearnedData = async (token, params = {}) => {
  try {
    // Server-side pagination: base endpoint (no /lookup) returns { items, totalCount }.
    const response = await apiClient.get(`/InternLessonLearned/pending`, {
      params: { pageNumber: 1, pageSize: 10, ...params },
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
      },
    })
    const d = response.data
    if (Array.isArray(d)) return { items: d, totalCount: d.length }
    return { items: d?.items ?? [], totalCount: d?.totalCount ?? 0 }
  } catch (error) {
    console.error('Error fetching lesson learned data:', error)
    throw error
  }
}
